export default "/images/6606fa1b0855fda690d1167c2bcfcba2.avif";